const WHATSAPP_URL = 'https://api.whatsapp.com/send?phone=+5511988532607'

export default {
    WHATSAPP_URL
}